import { config } from '@/config'

/** Get the full dashboard URL for a registry API */
export function apiDashboardUrl(uid: string) {
  return `${config.projects.dashboard}/registry/${uid}`
}
